import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"i-2138157150__a\" width=\"29\" height=\"28\" x=\"0\" y=\"0\" maskUnits=\"userSpaceOnUse\" style=\"mask-type:alpha;\"><path fill=\"#D9D9D9\" d=\"M.429 0h28v28h-28z\"></path></mask><g clip-path=\"url(#i-2138157150__b)\"><path fill=\"#85807D\" d=\"M21.229 5.158h2.905l-6.38 7.504 7.453 10.18H19.36l-4.579-6.186-5.242 6.186H6.633l6.758-8.026-7.137-9.658h5.994l4.136 5.65zM20.212 21.08h1.61L11.402 6.854H9.67z\"></path></g><defs><clipPath id=\"i-2138157150__b\"><path fill=\"#fff\" d=\"M6.323 5.158H25.27v17.684H6.323z\"></path></clipPath></defs>", 3)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "x"}) } }